import { useArticleContext } from '@/creditflowresearch/application/ArticlesAndStats/Article';
import RelatedDataSection from '@/creditflowresearch/ui/components/creditFlow/common/RelatedData/RelatedDataSection';
import RelatedData from '@/creditflowresearch/ui/components/creditFlow/common/RelatedData';

const ArticleRelatedData = () => {
  const {
    article,
    downloadAttachment,
  } = useArticleContext();
  const shouldRenderRelatedData = article.attachments.length > 0
    || article.deals.length > 0
    || article.issuers.length > 0
    || article.parents.length > 0;

  if (!shouldRenderRelatedData) {
    return null;
  }
  return (
    <RelatedData>
      <RelatedDataSection
        label="Attachments"
        collection={ article.attachments }
        onClick={ downloadAttachment }
        dataTest="articleAttachments"
        isDownload
      />
      <RelatedDataSection
        label="Related Deals"
        collection={ article.deals }
        dataTest="articleDeals"
      />
      <RelatedDataSection
        label="Related Parents"
        collection={ article.parents }
        dataTest="articleParents"
      />
      <RelatedDataSection
        label="Related Issuers"
        collection={ article.issuers }
        dataTest="articleIssuers"
      />
    </RelatedData>
  );
};

export default ArticleRelatedData;
